import React from 'react';
import { Box, Text, AspectRatio, Flex } from '@chakra-ui/react';
import SanityImage from 'gatsby-plugin-sanity-image';
import { RichText } from '../RichText';
import { ArrowLink } from '../ArrowLink';

function SectionLink({ data }) {
  const { body, title, link, image } = data || {};

  const Image = () => {
    const tempImage = image || link?.hero?.image;

    if (tempImage) {
      return (
        <AspectRatio ratio={16 / 9} overflow='hidden'>
          <Box
            transition='transform 1s ease-in-out'
            _groupHover={{
              transform: 'scale(1.1)',
            }}
          >
            <SanityImage
              {...tempImage}
              alt={tempImage?.asset?.altText}
              hotspot={tempImage.hotspot}
              crop={tempImage.crop}
              width={600}
              style={{
                objectFit: 'cover',
                objectPosition: 'center',
                height: '100%',
                width: '100%',
              }}
            />
          </Box>
        </AspectRatio>
      );
    }

    return null;
  };

  return (
    <Box
      _hover={{
        textDecoration: 'none',
      }}
      data-group
    >
      <Image />
      <Flex
        direction='column'
        gap={10}
        width='90%'
        padding={30}
        mt={{ base: -20, xl: -40 }}
        zIndex='1'
        position='relative'
        background='white'
        mx='auto'
      >
        <Text textStyle='h3' textTransform='uppercase' color='navy'>
          {title}
        </Text>
        <RichText value={body} fontWeight={300} />
        {link && (
          <ArrowLink
            title={`Go to ${link.title}`}
            link={{
              internal: {
                section: link.section,
                slug: {
                  current: link.slug.current,
                },
              },
            }}
          />
        )}
      </Flex>
    </Box>
  );
}

export default SectionLink;
